import React, { createRef } from 'react'
import {
  Grid,
  Paper,
  Tabs,
  Tab,
  Button as MuiButton,
  Typography,
  Input,
  FormControl,
} from '@material-ui/core'
import { connect } from 'react-redux'
import moment from 'moment'

import { EditableSwitch } from '../../../components/common/EditableComponents'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import { hasAccess } from '../../../utils/api'
import { Appcues } from '../../../utils/constants'
import { EditableDraftEditor } from '../../../components/common/EditableComponents'
import RenderHTML from '../../../components/Editor/RenderHTML'
import { EditableImageUploader, ImagePreview } from '../../../components/common/ImageUploader'
import { uploadAssetAPI } from '../../../api/assets'
import { isFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'
import { getStateCannabisDefinition } from '../../../api/compliance'
import { MarketingCodes } from './ManageReceipt/MarketingCodes'
import { QRCode } from './ManageReceipt/QRCode'

const fulfillmentOptions = {
  enableShopLicenseNumber: "Shop's license number",

  enableShopAddress: "Shop's address",

  enableShopPhoneNo: "Shop's phone number",

  enableLicenseeBusinessName: "Licensee's business name",

  enableEmployeeName: "Employee's name",

  enableEmployeeFullLastName: "Employee's last name",

  enableEmployeeId: "Employee's ID",

  enableDeliveryDriverName: "Delivery driver's name",

  enableDeliveryDriverFullLastName: "Delivery driver's last name",

  enableDeliveryDriverId: "Delivery driver's employee ID",

  enablePreparedByEmployeeName: "Prepared by's name",

  enablePreparedByEmployeeFullLastName: "Prepared by's last name",

  enablePreparedByEmployeeId: "Prepared by's employee ID",
  enablePackedByEmployeeName: "Packed by's name",
  enablePackedByEmployeeFullLastName: "Packed by's last name",
  enablePackedByEmployeeId: "Packed by's employee ID",
  enablePurchaseType: 'Purchase Type',
  enableSource: 'Order Source',

  enableQueueType: 'Queue Type',
  enableSalesChannel: 'Sales Channel (if exist)',
  enableScheduledWindow: 'Order Scheduled Window',

  enableMemberName: "Member's name",

  enableMemberMedicalNumber: "Member's med #",

  enableMemberFullLastName: "Member's last name",

  enableMemberId: "Member's ID",

  enableMemberAddress: "Member's address",

  enableMemberDeliveryAddress: "Member's delivery address",

  enableMemberPhoneNo: "Member's phone number",

  enableMemberDOB: "Member's date of birth",

  enableMemberLoyaltyPoints: "Member's loyalty points",

  enableNotes: "Member's notes",

  enableOrderDateTime: 'Order creation date and time',

  enableOrderNotes: "Order's notes",

  enableIncludeItemInSKU: "Product's SKU",

  enableBatchUniqueNumber: "Batch's unique number",

  enableBrand: "Product's brand",

  enableItemDiscount: "Product's discount",

  enableItemDiscountNotes: "Product's discount note",

  enablePromotions: 'Promotions',

  enableDiscountSubtractions: 'Discounts as subtractions',

  enableExciseTaxAsItem: 'Excise tax',

  enableTotalTax: 'Total tax',

  enableWPU: 'Weight Per Unit',

  enabledFreeText: 'Custom text above sales details',

  enabledBottomFreeText: 'Custom text below sales details',

  enableComplianceBarcode: 'Compliance Barcode (Overrides product SKU)',

  enableProductDescription: 'Cannabis Type',
  enableBundleExpansion: 'Include Bundle Items',
}

const productDescriptionOptions = [
  { value: 'CATEGORY_TYPE', label: 'Category type' },
  { value: 'CANNABIS_TYPE', label: 'Cannabis type' },
  { value: 'COMPLIANCE_TYPE', label: 'Compliance type' },
  { value: 'STATE_TYPE', label: 'State type' },
]

const getDiscountedValue = (val, isNegative) => {
  return isNegative ? `-${val}` : val
}

class ManageReceipts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'SALES',
      fulfillment: fulfillmentOptions,
      freeTexts: [],
      shop: props.shop || {},
      productDescriptionFlag: false,
      hasCannabisDefinition: false,
      buttonTop: '148px',
    }
  }

  componentDidMount() {
    const { shop = {} } = this.state
    let { receiptInfo = [] } = shop
    const freeTexts =
      (receiptInfo &&
        receiptInfo.length &&
        receiptInfo.map((receipt) => {
          return {
            enabledBottomFreeText: receipt.freeText,
            enabledFreeText: receipt.aboveFreeText,
            enableLicenseeBusinessName: receipt.licenseeBusinessName,
          }
        })) ||
      []
    this.setState({
      freeTexts,
    })
    const { address = {} } = shop
    const state = (address && address.state) || ''
    if (!receiptInfo) {
      //For new shops
      const enabledCAFields = state === 'CA'
      receiptInfo = [
        { receiptType: 'SALES' },
        { receiptType: 'FULFILLMENT' },
        {
          receiptType: 'DELIVERY',
          enableOrderDateTime: enabledCAFields,
          enableMemberName: enabledCAFields,
          enableMemberFullLastName: enabledCAFields,
          enableMemberId: enabledCAFields,
          enableMemberAddress: enabledCAFields,
          enableShopAddress: enabledCAFields,
          enableEmployeeName: enabledCAFields,
          enableEmployeeId: enabledCAFields,
          enablePreparedByEmployeeId: enabledCAFields,
          enableShopLicenseNumber: enabledCAFields,
        },
      ]
    } else if (receiptInfo && receiptInfo.length === 2) {
      //For shop that doesnt have the delivery receipt
      const enabledCAFields = (address && address.state === 'CA') || false
      receiptInfo = [
        ...receiptInfo,
        {
          receiptType: 'DELIVERY',
          enableOrderDateTime: enabledCAFields,
          enableMemberName: enabledCAFields,
          enableMemberFullLastName: enabledCAFields,
          enableMemberId: enabledCAFields,
          enableMemberAddress: enabledCAFields,
          enableShopAddress: enabledCAFields,
          enableEmployeeName: enabledCAFields,
          enableEmployeeId: enabledCAFields,
          enablePreparedByEmployeeId: enabledCAFields,
          enableShopLicenseNumber: enabledCAFields,
        },
      ]
    }
    this.setState({
      shop: { ...shop, receiptInfo: [...receiptInfo] },
    })
    getStateCannabisDefinition({ state, type: 'STATE_TYPE' }).then((res) => {
      this.setState({ hasCannabisDefinition: typeof res === 'object' && res !== null })
    })
    this.getFlags()
    window.addEventListener('scroll', this.addResponsiveness)
  }

  getFlags = async () => {
    const productDescriptionFlag = await isFeatureFlagEnable(
      UnleashToggles.PRODUCT_DESCRIPTION_RECEIPT,
    )
    this.setState({ productDescriptionFlag })
  }

  addResponsiveness = () => {
    const scrollY = window.scrollY
    this.setState({
      buttonTop: scrollY > 60 ? '40px' : '148px',
    })
  }

  changeActiveTab = (event, value) => {
    this.setState({
      activeTab: value,
    })
  }

  setOption = (event, index, key, receiptInfo, isSelect = false) => {
    const { shop = {} } = this.state

    const newValue = isSelect ? event.target.value : event.target.checked
    let updatedReceiptInfo = receiptInfo.slice(0)
    if (key === 'enabledBottomFreeText' && !newValue) {
      this.setFreeText(index, '')
    }
    if (key === 'enableProductDescription') {
      updatedReceiptInfo[index]['productDescriptionType'] = 'CANNABIS_TYPE'
    }
    updatedReceiptInfo[index][key] = newValue
    this.setState({
      shop: { ...shop, receiptInfo: [...updatedReceiptInfo] },
    })
  }

  updateMarketingCodes = (marketingCodes, index, receiptInfo) => {
    const { shop = {} } = this.state
    let updatedReceiptInfo = receiptInfo.slice(0)
    updatedReceiptInfo[index]['marketingCodes'] = marketingCodes
    this.setState({
      shop: { ...shop, receiptInfo: [...updatedReceiptInfo] },
    })
  }

  onEmailChange = (event, index, receiptInfo) => {
    const { shop = {} } = this.state
    let updatedReceiptInfo = receiptInfo.slice(0)
    updatedReceiptInfo[index]['emailMessage'] = event
    this.setState({
      shop: { ...shop, receiptInfo: [...updatedReceiptInfo] },
    })
  }

  uploadEmailAttachment = (file, type, url, index, receiptInfo) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        const { shop = {} } = this.state
        let updatedReceiptInfo = receiptInfo.slice(0)
        updatedReceiptInfo[index]['emailAttachment'] = response
        this.setState({
          shop: { ...shop, receiptInfo: [...updatedReceiptInfo] },
        })
        res(response)
      })
    })
  }

  onSave = () => {
    Appcues.track('Receipt settings saved')
    const { receiptInfo } = this.state.shop
    const { freeTexts = [] } = this.state
    const updatedReceiptInfo =
      receiptInfo &&
      receiptInfo.length &&
      receiptInfo.map((receipt, index) => {
        const freeText = (freeTexts[index] && freeTexts[index]['enabledBottomFreeText']) || ''
        const aboveFreeText = (freeTexts[index] && freeTexts[index]['enabledFreeText']) || ''
        const licenseeBusinessName =
          (freeTexts[index] && freeTexts[index]['enableLicenseeBusinessName']) || ''
        return { ...receipt, freeText, aboveFreeText, licenseeBusinessName }
      })
    this.props.updateShop({
      ...this.state.shop,
      receiptInfo: updatedReceiptInfo,
    })
  }

  setFreeText = (index, text, key) => {
    const { freeTexts = [] } = this.state
    let updatedFreeTexts = [...freeTexts]
    updatedFreeTexts[index] = updatedFreeTexts[index] || {}
    updatedFreeTexts[index][key] = text
    this.setState({
      freeTexts: updatedFreeTexts,
    })
  }

  removeProductDescriptionOption = (list, removeOptions) => {
    if (removeOptions.length === 0) return list
    return list.filter((item) => !removeOptions.some((item2) => item2 === item.value))
  }

  render() {
    const {
      freeTexts,
      shop = {},
      productDescriptionFlag = false,
      hasCannabisDefinition = false,
    } = this.state
    //const { shop={} } = this.props;
    const data = {
      SALES: [
        'enableShopLicenseNumber',
        {
          label: 'licensee business name',
          value: 'enableLicenseeBusinessName',
        },
        'enableShopAddress',
        'enableShopPhoneNo',
        'enableEmployeeName',
        'enableEmployeeFullLastName',
        'enableEmployeeId',
        'enablePreparedByEmployeeName',
        'enablePreparedByEmployeeFullLastName',
        'enablePreparedByEmployeeId',
        'enablePackedByEmployeeName',
        'enablePackedByEmployeeFullLastName',
        'enablePackedByEmployeeId',
        'enablePurchaseType',
        'enableSource',
        'enableQueueType',
        'enableSalesChannel',
        'enableMemberName',
        'enableMemberFullLastName',
        'enableMemberId',
        'enableMemberMedicalNumber',
        'enableMemberAddress',
        'enableMemberDOB',
        'enableMemberPhoneNo',
        'enableMemberLoyaltyPoints',
        'enableNotes',
        'enableOrderDateTime',
        'enableScheduledWindow',
        'enableOrderNotes',
        'enableIncludeItemInSKU',
        'enableBatchUniqueNumber',
        'enableComplianceBarcode',
        'enableBrand',
        'enableItemDiscount',
        'enableItemDiscountNotes',
        'enablePromotions',
        'enableDiscountSubtractions',
        'enableExciseTaxAsItem',
        'enableTotalTax',
        'enableBundleExpansion',
        'enableWPU',
        { label: 'text above sales details', value: 'enabledFreeText' },
        { label: 'text below sales details', value: 'enabledBottomFreeText' },
      ],
      FULFILLMENT: [
        'enableShopLicenseNumber',
        {
          label: 'licensee business name',
          value: 'enableLicenseeBusinessName',
        },
        'enableShopAddress',
        'enableShopPhoneNo',
        'enableEmployeeName',
        'enableEmployeeFullLastName',
        'enableEmployeeId',
        'enableDeliveryDriverName',
        'enableDeliveryDriverFullLastName',
        'enableDeliveryDriverId',
        'enablePreparedByEmployeeName',
        'enablePreparedByEmployeeFullLastName',
        'enablePreparedByEmployeeId',
        'enablePackedByEmployeeName',
        'enablePackedByEmployeeFullLastName',
        'enablePackedByEmployeeId',
        'enablePurchaseType',
        'enableSource',
        'enableQueueType',
        'enableSalesChannel',
        'enableMemberName',
        'enableMemberFullLastName',
        'enableMemberId',
        'enableMemberMedicalNumber',
        'enableMemberDeliveryAddress',
        'enableMemberAddress',
        'enableMemberDOB',
        'enableMemberPhoneNo',
        'enableMemberLoyaltyPoints',
        'enableNotes',
        'enableOrderDateTime',
        'enableScheduledWindow',
        'enableOrderNotes',
        'enableIncludeItemInSKU',
        'enableBatchUniqueNumber',
        'enableComplianceBarcode',
        'enableBrand',
        'enableItemDiscount',
        'enableItemDiscountNotes',
        'enablePromotions',
        'enableDiscountSubtractions',
        'enableExciseTaxAsItem',
        'enableTotalTax',
        'enableBundleExpansion',
        'enableWPU',
        { label: 'text above sales details', value: 'enabledFreeText' },
        { label: 'text below sales details', value: 'enabledBottomFreeText' },
      ],
      DELIVERY: [
        'enableShopLicenseNumber',
        {
          label: 'licensee business name',
          value: 'enableLicenseeBusinessName',
        },
        'enableShopAddress',
        'enableShopPhoneNo',
        'enableEmployeeName',
        'enableEmployeeFullLastName',
        'enableEmployeeId',
        'enableDeliveryDriverName',
        'enableDeliveryDriverFullLastName',
        'enableDeliveryDriverId',
        'enablePreparedByEmployeeName',
        'enablePreparedByEmployeeFullLastName',
        'enablePreparedByEmployeeId',
        'enablePackedByEmployeeName',
        'enablePackedByEmployeeFullLastName',
        'enablePackedByEmployeeId',
        'enablePurchaseType',
        'enableSource',
        'enableQueueType',
        'enableSalesChannel',
        'enableMemberName',
        'enableMemberFullLastName',
        'enableMemberId',
        'enableMemberMedicalNumber',
        'enableMemberDeliveryAddress',
        'enableMemberAddress',
        'enableMemberDOB',
        'enableMemberPhoneNo',
        'enableMemberLoyaltyPoints',
        'enableNotes',
        'enableOrderDateTime',
        'enableScheduledWindow',
        'enableOrderNotes',
        'enableIncludeItemInSKU',
        'enableBatchUniqueNumber',
        'enableComplianceBarcode',
        'enableBrand',
        'enableItemDiscount',
        'enableItemDiscountNotes',
        'enablePromotions',
        'enableDiscountSubtractions',
        'enableExciseTaxAsItem',
        'enableTotalTax',
        'enableBundleExpansion',
        'enableWPU',
        { label: 'text above sales details', value: 'enabledFreeText' },
        { label: 'text below sales details', value: 'enabledBottomFreeText' },
      ],
    }
    let removeOptions = []
    if (shop && shop.complianceType === 'MANUAL') removeOptions.push('COMPLIANCE_TYPE')
    if (!hasCannabisDefinition) removeOptions.push('STATE_TYPE')
    const filteredProductDescriptionOptions = this.removeProductDescriptionOption(
      productDescriptionOptions,
      removeOptions,
    )
    let { receiptInfo = [] } = shop
    const ReceiptSettings =
      (receiptInfo &&
        receiptInfo.length &&
        receiptInfo.map((receipt, index) => {
          if (this.state.activeTab === receipt.receiptType) {
            let keys = data[receipt.receiptType]
            if (productDescriptionFlag) {
              const brandIndex = keys.indexOf('enableBrand')
              if (brandIndex !== -1) {
                keys.splice(brandIndex + 1, 0, 'enableProductDescription')
              }
            }
            return (
              <Receipt
                key={index}
                index={index}
                keys={keys}
                data={receipt}
                setOption={this.setOption}
                receiptInfo={receiptInfo}
                shop={shop}
                setFreeText={this.setFreeText}
                freeText={freeTexts[index]}
                onEmailChange={this.onEmailChange}
                uploadEmailAttachment={this.uploadEmailAttachment}
                productDescriptionOptions={filteredProductDescriptionOptions}
                updateMarketingCodes={this.updateMarketingCodes}
              />
            )
          }
          return null
        })) ||
      null
    return (
      <Grid container>
        <Grid item container xs={12} sm={12} md={12} lg={12} className="cus_posi">
          <Grid item xs={12} sm={7} md={7} lg={7} className="cus_tabs">
            <Tabs
              value={this.state.activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.changeActiveTab}
              centered
            >
              <Tab label="WALK-INS" value="SALES" />
              <Tab label="FULFILLMENT" value="FULFILLMENT" />
              <Tab label="DELIVERY" value="DELIVERY" />
            </Tabs>
          </Grid>
          {hasAccess() ? (
            <Grid
              style={{
                position: 'fixed',
                top: this.state.buttonTop,
                right: '24px',
                transition: 'top 0.5s ease',
              }}
              item
              xs={12}
              sm={5}
              md={5}
              lg={5}
            >
              <MuiButton
                variant="raised"
                className="primary-button pull-right margin-bottom-small custom_btn"
                onClick={this.onSave}
              >
                Save
              </MuiButton>
            </Grid>
          ) : (
            <Grid item xs={12} sm={5} md={5} lg={5} />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography component="div">{ReceiptSettings}</Typography>
        </Grid>
      </Grid>
    )
  }
}

class ReceiptItem extends React.Component {
  render() {
    const { data = {}, item = {} } = this.props
    const showItemSKU = (data && data['enableIncludeItemInSKU']) || false
    const showBatchUniqueNumber = (data && data['enableBatchUniqueNumber']) || false
    const showComplianceBarcode = (data && data['enableComplianceBarcode']) || false
    const showBrandName = (data && data['enableBrand']) || false
    const showDiscount = (data && data['enableItemDiscount']) || false
    const showDiscountNotes = (data && data['enableItemDiscountNotes']) || false
    const showWPU = (data && data['enableWPU']) || false
    const showProductDescription = (data && data['enableProductDescription']) || false
    const productDescriptionType = data && data['productDescriptionType']
    const enableBundleExpansion = data && data['enableBundleExpansion']
    const showDiscountSubtractions = (data && data['enableDiscountSubtractions']) || false
    const showPromotions = (data && data['enablePromotions']) || false
    let productDescriptionText = ''
    let productDescriptionHeader = ''
    switch (productDescriptionType) {
      case 'CATEGORY_TYPE':
        productDescriptionText = item.isCompliance ? 'Cannabis' : 'Non Cannabis'
        productDescriptionHeader = 'Category Type'
        break
      case 'CANNABIS_TYPE':
        productDescriptionText = item.isCompliance ? 'Edible' : 'Non-Cannabis'
        productDescriptionHeader = 'Cannabis Type'
        break
      case 'COMPLIANCE_TYPE':
        productDescriptionText = item.isCompliance ? 'Tablet' : 'NA'
        productDescriptionHeader = 'Compliance Type'
        break
      case 'STATE_TYPE':
        productDescriptionText = item.isCompliance ? 'Solid Chocolates' : 'NA'
        productDescriptionHeader = 'State Type'
        break
    }
    return (
      <React.Fragment>
        <Grid container xs={12} sm={12} md={12} lg={12} className="nopadding">
          <Grid item xs={12} sm={3} md={3} lg={3} className="nopadding">
            {item.isCompliance ? (
              <React.Fragment>
                {showItemSKU && !showComplianceBarcode ? (
                  <div>
                    <strong>SKU</strong>
                    <p>{item.sku}</p>
                  </div>
                ) : null}
                {showComplianceBarcode ? (
                  <div>
                    <strong>Batch ID</strong>
                    <p>{item.batchId}</p>
                  </div>
                ) : null}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {showItemSKU ? (
                  <div>
                    <strong>SKU</strong>
                    <p>57B1IU21BBGL</p>
                  </div>
                ) : null}
                {showComplianceBarcode ? (
                  <div>
                    <strong>Batch ID</strong>
                    <p>57B1IU21BBGL</p>
                  </div>
                ) : null}
              </React.Fragment>
            )}
            {showBatchUniqueNumber ? <p>{`UID: ${item.uid}`}</p> : null}
            <p>-Qty: 1</p>
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} className="nopadding">
            <strong>Description</strong>
            <p>
              {item.productname} {showWPU ? '1 ea' : null}
            </p>
            {showBrandName ? <p>By: Brand</p> : null}
          </Grid>
          {showProductDescription && productDescriptionType ? (
            <Grid item xs={12} sm={3} md={3} lg={3} className="nopadding">
              <strong>{productDescriptionHeader}</strong>
              <p>{productDescriptionText}</p>
            </Grid>
          ) : null}
          <Grid item xs={12} sm={2} md={2} lg={2} className="nopadding">
            <strong>Price</strong>
            <p>{item.price}</p>
          </Grid>
          {showDiscount ? (
            <Grid item xs={12} sm={2} md={2} lg={2} className="nopadding">
              <strong>Discount</strong>
              <p>{getDiscountedValue(`${item.discount}`, showDiscountSubtractions)}</p>
            </Grid>
          ) : null}
          {showDiscountNotes ? (
            <Grid item xs={12} sm={2} md={2} lg={2} className="nopadding">
              <strong>Discount Notes</strong>
              <p>N/A</p>
            </Grid>
          ) : null}
          {showPromotions ? (
            <Grid item xs={12} sm={2} md={2} lg={2} className="nopadding">
              <strong>Promo</strong>
              <p>
                {item.promo}: {getDiscountedValue(item.promoAmount, showDiscountSubtractions)}
              </p>
            </Grid>
          ) : null}
          {enableBundleExpansion ? (
            <Grid item xs={12} sm={12} md={12} lg={12} className="nopadding">
              <strong>-Includes:</strong>
              <p>-- Bundle Item 1</p>
              {showItemSKU ? <p>--- SKU: MYITEM123</p> : null}
              {showBrandName ? <p>--- Brand: My Brand</p> : null}
              <p>--- Qty: 2.0 ea @ $45.00</p>

              <p>-- Bundle Item 2</p>
              {showItemSKU ? <p>--- SKU: ITEM2SKU</p> : null}
              {showBrandName ? <p>--- Brand: My Brand 2</p> : null}
              <p>--- Qty: 3.0 ea @ $10.00</p>
            </Grid>
          ) : null}
        </Grid>
      </React.Fragment>
    )
  }
}

class Receipt extends React.Component {
  constructor(props) {
    super(props)
    this.receiptRef = createRef()
    this.state = {}
  }

  componentDidMount() {
    this.adjustReceiptWidth()
    window.addEventListener('scroll', this.addResponsiveness)
    window.addEventListener('resize', this.adjustReceiptWidth)
  }

  addResponsiveness = () => {
    const scrollY = window.scrollY
    this.setState({
      scrolled: scrollY > 60,
    })
  }

  adjustReceiptWidth = () => {
    if (this.receiptRef.current) {
      const wrapperWidth = this.receiptRef.current.clientWidth
      this.setState({
        receiptWidth: `${wrapperWidth}px`,
        positionRelative: window.innerWidth < 960,
      })
    }
  }

  render() {
    const { keys, data = {}, index, receiptInfo, shop = {}, freeText = '' } = this.props
    const keysWrapper = keys.map((key) => {
      return {
        key: key,
        hasText: key && key.value,
      }
    })
    const showShopLicense = (data && data['enableShopLicenseNumber']) || false
    const showShopAddress = (data && data['enableShopAddress']) || false
    const showShopPhoneNumber = (data && data['enableShopPhoneNo']) || false
    const showLicenseeBusinessName = (data && data['enableLicenseeBusinessName']) || false
    const showEmployeeName = (data && data['enableEmployeeName']) || false
    const showEmployeeLastName = (data && data['enableEmployeeFullLastName']) || false
    const showEmployeeID = (data && data['enableEmployeeId']) || false
    const showDeliveryDriverName = (data && data['enableDeliveryDriverName']) || false
    const showScheduledWindow = (data && data['enableScheduledWindow']) || false
    const showSalesChannel = (data && data['enableSalesChannel']) || false
    const showDeliveryDriverLastName = (data && data['enableDeliveryDriverFullLastName']) || false
    const showDeliveryDriverID = (data && data['enableDeliveryDriverId']) || false
    const showPrepareEmployeeName = (data && data['enablePreparedByEmployeeName']) || false
    const showPrepareEmployeeLastName =
      (data && data['enablePreparedByEmployeeFullLastName']) || false
    const showPrepareEmployeeID = (data && data['enablePreparedByEmployeeId']) || false
    const showPackedByEmployeeName = (data && data['enablePackedByEmployeeName']) || false
    const showPackedByEmployeeLastName =
      (data && data['enablePackedByEmployeeFullLastName']) || false
    const showPackedByEmployeeId = (data && data['enablePackedByEmployeeId']) || false
    const showMemberName = (data && data['enableMemberName']) || false
    const showMemberMedicalNumber = (data && data['enableMemberMedicalNumber']) || false
    const showMemberLastName = (data && data['enableMemberFullLastName']) || false
    const showMemberID = (data && data['enableMemberId']) || false
    const showMemberDeliveryAddress = (data && data['enableMemberDeliveryAddress']) || false
    const showMemberAddress = (data && data['enableMemberAddress']) || false
    const showMemberDOB = (data && data['enableMemberDOB']) || false
    const showMemberPhoneNumber = (data && data['enableMemberPhoneNo']) || false
    const showMemberLoyalty = (data && data['enableMemberLoyaltyPoints']) || false
    const showNotes = (data && data['enableNotes']) || false
    const showCreationDateTime = (data && data['enableOrderDateTime']) || false
    const showOrderNotes = (data && data['enableOrderNotes']) || false
    const showExciseTax = (data && data['enableExciseTaxAsItem']) || false
    const showTotalTax = (data && data['enableTotalTax']) || false
    const showSource = (data && data['enableSource']) || false
    const showQueueType = (data && data['enableQueueType']) || false
    const enableBundleExpansion = (data && data['enableBundleExpansion']) || false
    const dataQueueType = data
      ? data.receiptType === 'SALES'
        ? 'WalkIn'
        : data.receiptType === 'FULFILLMENT' || data.receiptType === 'DELIVERY'
        ? 'Delivery'
        : null
      : null
    const showTransType = (data && data['enablePurchaseType']) || false
    const marketingCodes = (data && data.marketingCodes) || []
    const showPromotion = (data && data['enablePromotions']) || false
    const showDiscountSubtractions = (data && data['enableDiscountSubtractions']) || false
    return (
      <Grid container xs={12} sm={12} md={12} lg={12} className="abc">
        <Grid item xs={12} sm={12} md={7} lg={8} className="nopadding receipt_options_container">
          {keysWrapper &&
            keysWrapper.length &&
            keysWrapper.map((wrapper, i) => {
              const key = wrapper.key
              if (!wrapper.hasText) {
                return (
                  <Grid
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="receipt_options"
                    key={i}
                  >
                    <Grid item xs={12} sm={8} md={8} lg={8} className="nopadding">
                      <p>{fulfillmentOptions[key]}</p>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={4}>
                      <Grid alignItems="center" container>
                        <Grid item xs={12} sm={4} md={4} lg={4}>
                          <EditableSwitch
                            onChange={(event) => {
                              this.props.setOption(event, index, key, receiptInfo)
                            }}
                            checked={data[key] || false}
                            value={data[key]}
                            editMode={true}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              } else {
                const enabledText = (data && data[key.value]) || false
                return (
                  <Grid container xs={12} sm={12} md={12} lg={12} key={i}>
                    <Grid xs={12} sm={8} md={8} lg={8} className="nopadding">
                      <p>{fulfillmentOptions[key.value]}</p>
                    </Grid>
                    <Grid xs={12} sm={4} md={4} lg={4}>
                      <EditableSwitch
                        onChange={(event) =>
                          this.props.setOption(event, index, key.value, receiptInfo)
                        }
                        checked={data[key.value] || false}
                        value={data[key.value]}
                        editMode={true}
                      />
                    </Grid>
                    {enabledText ? (
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className="receipt_options"
                        style={{ marginBottom: 20 }}
                      >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                          <FormControl style={{ width: '35vh' }}>
                            <Input
                              multiline={true}
                              rows={2}
                              onChange={(e) =>
                                this.props.setFreeText(index, e.target.value, key.value)
                              }
                              value={(freeText && freeText[key.value]) || ''}
                              placeholder={`Enter ${key.label}`}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : null}
                  </Grid>
                )
              }
            })}
          <Grid container className="email_cus_msg">
            <Grid item xs={12}>
              <Grid container xs={12} sm={12} md={12} lg={12} className="receipt_options">
                <p>Marketing Codes</p>
              </Grid>
              <MarketingCodes
                codes={marketingCodes}
                setCodes={(newCodes) =>
                  this.props.updateMarketingCodes(newCodes, index, receiptInfo)
                }
              />
            </Grid>
            <Grid
              style={{ paddingTop: '16px' }}
              className="nopadding"
              item
              xs={12}
              sm={4}
              md={4}
              lg={4}
            >
              Email Custom Message
            </Grid>
            <Grid className="editField" item xs={12} sm={8} md={8} lg={8} style={{ padding: 20 }}>
              <EditableDraftEditor
                onChange={(event) => this.props.onEmailChange(event, index, receiptInfo)}
                emailMessage={data.emailMessage}
                editMode={true}
                valueToRender={<RenderHTML message={data.emailMessage} />}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid className="nopadding" item xs={12} sm={4} md={4} lg={4}>
              Email Attachment
            </Grid>
            <Grid className="editField" item xs={12} sm={8} md={8} lg={8}>
              <EditableImageUploader
                editMode={true}
                valueToRender={
                  <ImagePreview src={data.emailAttachment && data.emailAttachment.thumbURL} />
                }
                src={data.emailAttachment && data.emailAttachment.thumbURL}
                imageUploadAPI={(file, type, url) =>
                  this.props.uploadEmailAttachment(file, type, url, index, receiptInfo)
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={4}>
          <div ref={this.receiptRef}>
            <Paper
              style={{
                position: this.state.positionRelative ? 'relative' : 'fixed',
                right: '24px',
                top: this.state.scrolled ? '88px' : '196px',
                transition: 'top 0.5s ease',
                boxSizing: 'border-box',
                overflow: 'auto',
                height: this.state.scrolled ? 'calc(100% - 108px)' : 'calc(100% - 216px)',
                width: `${this.state.receiptWidth}` || '100%',
              }}
              elevation={4}
              className="receipt_container"
            >
              <p>
                Today's date: {`${moment().format('MM/DD/YYYY')}, ${moment().format('hh:mm A')}`}
              </p>
              <p>{(shop && shop.name) || ''}</p>
              {showShopLicense ? (
                <p>Shop's license number: {(shop && shop.license) || ''}</p>
              ) : null}
              {showLicenseeBusinessName ? (
                <p>Business name: {freeText['enableLicenseeBusinessName'] || ''}</p>
              ) : null}
              {showCreationDateTime ? (
                <p>
                  {' '}
                  Created on: {`${moment().format('MM/DD/YYYY')}, ${moment().format('hh:mm A')}`}
                </p>
              ) : null}
              {showShopAddress ? (
                <div>
                  <p>
                    Shop's address: {(shop && shop.address && shop.address.address) || ''} -{' '}
                    {(shop &&
                      shop.address &&
                      `${shop.address.city}, ${shop.address.state} ${shop.address.zipCode}`) ||
                      ''}
                  </p>
                </div>
              ) : null}
              {showShopPhoneNumber ? (
                <p>Shop's phone : {(shop && shop.phoneNumber) || ''}</p>
              ) : null}
              {data && data.receiptType === 'FULFILLMENT' && <p>Fulfillment step: FULFILL</p>}
              {showPrepareEmployeeName ? (
                <p>
                  Prepared by: Marry {showPrepareEmployeeLastName ? 'Jen' : 'J.'}{' '}
                  {showPrepareEmployeeID ? '(ce243)' : null}
                </p>
              ) : null}
              <p>Prepared date: 04/03/2018, 3:06AM</p>
              {showPackedByEmployeeName ? (
                <p>
                  Packed by: Marry {showPackedByEmployeeLastName ? 'Jen' : 'J.'}{' '}
                  {showPackedByEmployeeId ? '(ce243)' : null}
                </p>
              ) : null}
              {showEmployeeName ? (
                <p>
                  Employee: Marry {showEmployeeLastName ? 'Jen' : 'J.'}{' '}
                  {showEmployeeID ? '(ce243)' : null}
                </p>
              ) : null}
              {showSource ? <p>Source: {showSource ? 'Online Widget' : null}</p> : null}
              {showQueueType ? <p>Queue Type: {dataQueueType}</p> : null}
              {showSalesChannel ? <p>Sales Channel: Web</p> : null}
              {showDeliveryDriverName ? (
                <p>
                  Delivery driver: Marry {showDeliveryDriverLastName ? 'Jen' : 'J.'}{' '}
                  {showDeliveryDriverID ? '(ce243)' : null}
                </p>
              ) : null}
              <p>Trans #: 2487</p>
              {showTransType && <p>Purchase Type: Adult Use</p>}
              <p>Trans date: 04/03/2018, 11:39AM</p>
              {showScheduledWindow ? (
                <div>
                  <p>Complete After: 04/03/2018, 11:39 AM</p>
                  <p>Complete By: 04/03/2018, 12:00 PM</p>
                </div>
              ) : null}
              {showMemberName ? (
                <p>
                  Member: {`${'FTP Nicole'} ${showMemberLastName ? ' Parker' : 'P.'}`}{' '}
                  {showMemberID ? '(ch243)' : null}
                </p>
              ) : null}
              {showMemberMedicalNumber ? <p>Med #: 8749201865</p> : null}
              {showMemberPhoneNumber ? <p>Member's phone: 123-456-7890</p> : null}
              {showMemberDeliveryAddress ? (
                <div>
                  <p>Member's delivery address: 147 Shelley Circle - Ventura, CA 93003</p>
                </div>
              ) : null}
              {showMemberAddress ? (
                <div>
                  <p>Member's address: 146 Shelley Circle - Ventura, CA 93003</p>
                </div>
              ) : null}
              {showMemberDOB ? (
                <div>
                  <p>Member's date of birth: 06/14/1990</p>
                </div>
              ) : null}
              {showMemberLoyalty ? <p>Member's loyalty points: 75</p> : null}
              {showNotes ? <p>Member's notes: Notes</p> : null}
              <p className="receipt_border"></p>
              {freeText && freeText['enabledFreeText'] ? (
                <p className="receipt_border">{(freeText && freeText['enabledFreeText']) || ''}</p>
              ) : null}
              <strong style={{ margin: '5px 0' }}>SALE</strong>
              <ReceiptItem
                data={data}
                item={{
                  sku: '3JEA4SDBS9HUG',
                  productname: '420 Chocolate',
                  price: '$50.00',
                  discount: '$5.00',
                  batchId: '1A4FF0300000029000016897',
                  isCompliance: true,
                  promo: 'Promo 1',
                  promoAmount: '$5.00',
                  uid: '10BAT0',
                }}
              />
              <ReceiptItem
                data={data}
                item={{
                  sku: '57B1IU21BBGL',
                  productname: '707 Headband CO',
                  price: '$28.00',
                  discount: '$5.00',
                  batchId: '57B1IU21BBGL',
                  isCompliance: false,
                  promo: 'Promo 2',
                  promoAmount: '$5.00',
                  uid: '10BAT1',
                }}
              />
              {showPromotion ? (
                <p>
                  <strong>Cart Promos</strong>
                </p>
              ) : null}
              {showPromotion ? (
                <div className="pull-left text-left">
                  <p>Cart Promotion 1</p>
                  <p>Cart Promotion Example...</p>
                </div>
              ) : null}
              {showPromotion ? (
                <div className="pull-right text-right">
                  <p>{getDiscountedValue('$0.50', showDiscountSubtractions)}</p>
                  <p>{getDiscountedValue('$1.00', showDiscountSubtractions)}</p>
                </div>
              ) : null}
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className="nopadding"
                style={{ display: 'inline-block', margin: '10px 0' }}
              >
                <strong className="pull-left">Subtotal</strong>
                <strong className="pull-right">$78.00</strong>
              </Grid>
              <div className="pull-left text-left">
                {showExciseTax ? <p>Excise Tax</p> : null}
                {showExciseTax ? <p>Excise Tax</p> : null}
                <p>Custom fee</p>
                <p>City Tax</p>
                <p>County Tax</p>
                <p>State Tax</p>
                {showTotalTax ? <p>Total Tax</p> : null}
              </div>
              <div className="pull-right text-right">
                <p>{showExciseTax ? '($12.00)' : null}</p>
                <p>{showExciseTax ? '$7.50' : null}</p>
                <p>$0.85</p>
                <p>$0.86</p>
                <p>$0.86</p>
                <p>$0.87</p>
                {showTotalTax ? <p>$2.59</p> : null}
              </div>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className="receipt_border nopadding"
                style={{ margin: '5px 0' }}
              >
                <Grid container className="receipt_border" />
                <Grid container xs={12} sm={6} md={6} lg={6} justify="flex-start">
                  <p>Total</p>
                </Grid>
                <Grid container xs={12} sm={6} md={6} lg={6} justify="flex-end">
                  <p>$85.09</p>
                </Grid>
              </Grid>
              <Grid container xs={12} sm={12} md={12} lg={12} className="nopadding">
                <div>
                  {showOrderNotes ? <p>Order notes: Show Walk-ins or Sales</p> : null}
                  <p>Payment type: Check</p>
                  <p>Total payment received: $85.09</p>
                  <p>Change due: $0.00</p>
                  <p>The cannabis excise taxes are included in the total amount of this invoice.</p>
                </div>
                <Grid
                  item
                  xs={12}
                  className="nopadding receipt_border"
                  style={{ margin: '10px 0' }}
                >
                  <p className="receipt_border"></p>
                  <p className="pull-left">Member Signature</p>
                </Grid>
                <Grid container justify="center">
                  Member Signature
                </Grid>
                {freeText && freeText['enabledBottomFreeText'] ? (
                  <p>{(freeText && freeText['enabledBottomFreeText']) || ''}</p>
                ) : null}
                <Grid
                  container
                  style={{
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                  xs={12}
                >
                  {marketingCodes.map((code) => (
                    <QRCode code={code} />
                  ))}
                </Grid>
              </Grid>
            </Paper>
          </div>
        </Grid>
      </Grid>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
}))(ShopSettingsWithUpdate(ContainerWithTitle(ManageReceipts, 'Manage Receipt Settings')))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ManageReceipts.js